import AxiosMaster from '../AxiosFactory';

let API = function () {
    this.getDirect = function (url) {
        return AxiosMaster.getDirect(url);
    };
    this.getAllPatients = function () {
        return AxiosMaster.post(`/getPatientDets`);
    };
    this.getPatientById = function (id) {
        return AxiosMaster.post(`/getPatientDets/${id}`);
    };
    this.addNewPatient = function (data) {
        return AxiosMaster.post(`/api/user/addPatientToClinic`, data);
    };
    this.deletePatientById = function (id) {
        return AxiosMaster.put(`/delPatient/${id}`);
    };
    this.updatePatientById = function (id, data) {
        return AxiosMaster.post(`/editPatient/${id}`, data);
    };
    this.fetchPatientsByClinicMaster = function (data) {
        return AxiosMaster.post(`/api/user/getPatients`, data)
    };
    this.fetchPatientDetailsByClinicMasterAndPatientID = function (data) {
        return AxiosMaster.post(`/api/user/getPatients`, data)
    };
    this.editPatientDetails = function (data) {
        return AxiosMaster.put(`/api/user/editPatient`, data)
    };
    this.searchPatient = function (data) {
        return AxiosMaster.post(`/api/user/searchPatients`, data)
    };
    this.deletePatient = function (data) {
        return AxiosMaster.put(`/api/user/deletePatient`, data)
    };
    this.getPatientsByPagination = function (data) {
        return AxiosMaster.post(`/api/user/getPatientsV2`, data)
    };

    //Clinic Master APIs

    this.createClinicMaster = function (data) {
        return AxiosMaster.post(`/api/user/signup`, data);
    };
    this.oldcreateClinicMaster = function (data) {
        return AxiosMaster.post(`/clinicmaster/create`, data);
    };
    this.listClinicMaster = function () {
        return AxiosMaster.post(`/clinicmaster/read`);
    };
    this.getClinicMasterById = function (id) {
        return AxiosMaster.post(`/clinicmaster/read/${id}`);
    };
    this.updateClinicMasterById = function (id, data) {
        return AxiosMaster.post(`/clinicmaster/update/${id}`, data);
    };
    this.deleteClinicMaster = function (data) {
        return AxiosMaster.post(`/clinicmaster/delete`, data);
    };
    this.getClinicDetailsFromMaster = function (id) {
        return AxiosMaster.post(`/clinicmaster/readwithcl/${id}`);
    };

    //Clinic  APIs


    this.createClinic = function (data) {
        return AxiosMaster.post(`/clinic/create`, data);
    };
    this.listClinics = function () {
        return AxiosMaster.post(`/clinic/read`, {'all': true});
    };
    this.getClinicById = function (id, data) {
        return AxiosMaster.post(`/clinic/read/${id}`, data);
    };
    this.updateClinicById = function (id, data) {
        return AxiosMaster.post(`/clinic/update/${id}`, data);
    };
    this.deleteClinicById = function (id) {
        return AxiosMaster.put(`/clinic/delete/${id}`);
    };
    this.listClinicsWithParentClinicMaster = function (id) {
        return AxiosMaster.post(`/clinic/readwithcm/${id}`);
    };

    //Doctor APIs

    this.createDoctor = function (data) {
        return AxiosMaster.post(`/api/user/addDoctorToClinic`, data);
    };
    this.getAllDoctors = function () {
        return AxiosMaster.post(`/doctor/read`);
    };
    this.getAllNewDoctorsApi = function () {
        return AxiosMaster.post(`/api/user/getDoctorsV2`);
    };
    this.getDoctorById = function (id) {
        return AxiosMaster.post(`/doctor/read/${id}`);
    };
    this.updateDoctorById = function (id, data) {
        return AxiosMaster.post(`/doctor/update/${id}`, data);
    };
    this.deleteDoctorById = function (id) {
        return AxiosMaster.put(`/doctor/delete/${id}`);
    };
    this.getDoctorsByClinicId = function (id) {
        return AxiosMaster.post(`/doctor/readbycl/${id}`);
    };
    this.updateDoctorsByClinicId = function (id, data) {
        return AxiosMaster.post(`/doctor/updatedocbycl/${id}`, data);
    };
    this.checkDoctorSubscription = function (data) {
        return AxiosMaster.post(`/doctorclinic/checkSubscription`, data);
    };
    this.searchDoctors = function (data) {
        return AxiosMaster.post(`/api/user/searchDoctors`, data)
    };
    this.deleteDoctor = function (data) {
        return AxiosMaster.put(`/api/user/deleteDoctor`, data)
    };

    //Category API

    this.createCategory = function (data) {
        return AxiosMaster.post(`/category/create`, data);
    };
    this.getAllCategories = function () {
        return AxiosMaster.post(`/category/read`);
    };
    this.updateCategory = function (id, data) {
        return AxiosMaster.post(`/category/update/${id}`, data);
    };
    this.deleteCategory = function (id) {
        return AxiosMaster.post(`/category/delete/${id}`);
    };
    this.getCategoryByRole = function (role) {
        return AxiosMaster.post(`/category/read?role="${role}"`);
    };

    //Speciality API

    this.createSpeciality = function (data) {
        return AxiosMaster.post(`/speciality/create`, data);
    };
    this.getAllSpecialities = function () {
        return AxiosMaster.post(`/speciality/read`);
    };
    this.updateSpeciality = function (id, data) {
        return AxiosMaster.post(`/speciality/update/${id}`, data);
    };
    this.deleteSpeciality = function (id) {
        return AxiosMaster.post(`/speciality/delete/${id}`);
    };
    this.getSpecialityByRole = function (role) {
        return AxiosMaster.post(`/speciality/read?role="${role}"`);
    };

    //Services API

    this.createService = function (data) {
        return AxiosMaster.post(`/service/create`, data);
    };
    this.getAllServices = function () {
        return AxiosMaster.post(`/service/read`);
    };
    this.updateService = function (id, data) {
        return AxiosMaster.post(`/service/update/${id}`, data);
    };
    this.deleteService = function (id) {
        return AxiosMaster.post(`/service/delete/${id}`);
    };
    this.getServiceByRole = function (role) {
        return AxiosMaster.post(`/service/read?role="${role}"`);
    };

    //Appointment API

    this.createAppointmentByAdmin = function (data) {
        return AxiosMaster.post(`/api/appointment/adminCreateAppointment`, data)
    };
    this.createAppointment = function (PatientId, DoctorId, ClinicId, data) {
        return AxiosMaster.post(`/appointment/create/${PatientId}/${DoctorId}/${ClinicId}`, data);
    };
    this.updateAppointment = function (data) {
        return AxiosMaster.put(`/api/appointment/editAppointmentDetail`, data);
    };
    // this.deleteAppointment = function (id) {
    //     return AxiosMaster.post(`/appointment/delete/${id}`);
    // };
    this.getAppointment = function (data) {
        return AxiosMaster.post(`/api/appointment/getApppointments`, data);
    };
    this.deleteAppointment = function (data) {
        return AxiosMaster.put(`/api/appointment/deleteAppointmentDetail`, data);
    };
    this.deleteAppointmentHeader = function (data) {
        return AxiosMaster.put(`/api/appointment/deleteAppointmentHeader`, data);
    };

    this.getAppointmentRequests = function (data) {
        return AxiosMaster.post(`/api/appointment/getAppointmentsRequests`, data);
    };
    this.approveAppointmentRequest = function (data) {
        return AxiosMaster.put(`/api/appointment/acceptAppointment`, data);
    };
    this.sendReminder = function (data) {
        return AxiosMaster.post(`/api/appointment/sendReminder`, data);
    };
    //Custom Report API

    this.getCustomReportList = function (data) {
        return AxiosMaster.post(`/api/report/custom/getReports`, data, {headers: {token: '9091235f3e4247be5a1608f934727c90123'}});
    };
    this.createCustomReport = function (data) {
        return AxiosMaster.post(`/api/report/custom/createReport`, data, {headers: {token: '9091235f3e4247be5a1608f934727c90123'}});
    };
    this.uploadCustomReport = function (data) {
        return AxiosMaster.post(`/api/report/custom/getS3SignedUrl`, data, {headers: {token: '9091235f3e4247be5a1608f934727c90123'}});
    };
    this.getAllCustomPatient = function (data) {
        return AxiosMaster.post(`/api/user/custom/getPatients`, data, {headers: {token: '9091235f3e4247be5a1608f934727c90123'}});
    };

    //Report API

    this.getReportList = function (data) {
        return AxiosMaster.post(`/api/report/getReports`, data);
    };
    this.createReport = function (data) {
        return AxiosMaster.post(`/api/report/createReport`, data);
    };
    this.createReportWithEditor = function (data) {
        return AxiosMaster.post(`/api/report/createReportWithEditor`, data);
    };
    this.uploadReport = function (data) {
        return AxiosMaster.post(`/api/report/getS3SignedUrl`, data);
    };
    this.updateReport = function (data) {
        return AxiosMaster.put(`/api/report/editReport`, data);
    };
    this.deleteReport = function (data) {
        return AxiosMaster.put(`/api/report/deleteReport`, data);
    };
    this.getReportById = function (patient_id, clinic_master_id, doctor_id, id) {
        return AxiosMaster.post(`/api/report/getReports?patient_id=${patient_id}&clinic_master_id=${clinic_master_id}&doctor_id=${doctor_id}&id=${id}`);
    };

    //Prescription API

    this.createPrescription = function (PatientId, DoctorId, AppointmentId, ClinicId, data) {
        return AxiosMaster.post(`/prescription/create/${AppointmentId}/${PatientId}/${ClinicId}/${DoctorId}`, data);
    };
    this.updatePrescription = function (id, data) {
        return AxiosMaster.post(`/prescription/update/${id}`, data);
    };
    this.deletePrescription = function (id) {
        return AxiosMaster.post(`/prescription/delete/${id}`);
    };
    this.getPrescriptionById = function (id) {
        return AxiosMaster.post(`/prescription/read/${id}`);
    };

    //Permission API

    this.getAllPermissionList = function () {
        return AxiosMaster.get(`/api/user/getPermissionsMaster`);
    };
    this.addClinicRoles = function (data) {
        return AxiosMaster.post(`/api/user/createClinicRoles`, data);
    };
    this.editClinicRoles = function (data) {
        return AxiosMaster.put(`/api/user/editClinicRoles`, data);
    };
    this.getPermissionForClinic = function (id) {
        return AxiosMaster.get(`/api/user/getMyClinicRoles?clinic_master_id=${id}`);
    };
    this.getPermissionForSpecificDocument = function (clinic_master_id, id) {
        return AxiosMaster.get(`/api/user/getMyClinicRoles?clinic_master_id=${clinic_master_id}&_id=${id}`)
    };
    this.AllUserToClinic = function (data) {
        return AxiosMaster.post(`/api/user/addUserToClinic`, data);
    };
    this.AllDoctorToClinic = function (data) {
        return AxiosMaster.post(`/api/user/addUserToClinic`, data);
    };
    this.getUsersList = function (data) {
        return AxiosMaster.post(`/api/user/getUsers`, data);

    };
    this.editUsers = function (data) {
        return AxiosMaster.put(`/api/user/editUser`, data);
    };

    //Upload Api

    this.uploadClinicImage = function (data) {
        return AxiosMaster.post(`/upload/ClinicImages`, data);
    };
    this.uploadDoctorImage = function (data) {
        return AxiosMaster.post(`/upload/DoctorImages`, data);
    };
    this.uploadPatientImage = function (data) {
        return AxiosMaster.post(`/upload/PatientImages`, data);
    };
    this.uploadReportImage = function (data) {
        return AxiosMaster.post(`/upload/Reports`, data);
    };
    this.uploadPrescriptionImage = function (data) {
        return AxiosMaster.post(`/upload/Prescription`, data);
    };
    this.uploadSelfReportImage = function (data) {
        return AxiosMaster.post(`/upload/selfReport`, data);
    };

    //Login

    this.loginApi = function (data) {
        return AxiosMaster.post(`/api/user/login`, data);
    };

    //Analytics

    this.fetAnalytticsStats = function (data) {
        return AxiosMaster.post(`/api/analytics/getBusinessStats`, data);
    };

    this.getOtpAnalytics = function (data) {
        return AxiosMaster.post(`/api/report/getReportsOtpAnalytics`, data)
    };

    this.getReportsPatientsAnalytics = function (data) {
        return AxiosMaster.post(`/api/report/getReportsPatientsAnalytics`, data)
    };

    //Validate User

    this.validateUser = function (data) {
        return AxiosMaster.post(`/api/user/validateUsername`, data);
    };

    this.changePassword = function (data) {
        return AxiosMaster.put(`/api/user/changeUserPassword`, data);
    };

    //Report Open Url

    this.openReport = function (data) {
        return AxiosMaster.post(`/api/report/getReportsV2`, data);
    };


    //Get Events

    this.getEvents = function (data) {
        return AxiosMaster.post(`/api/user/getEvents`, data);
    };

    //JD API

    this.getAllLeads = function (data) {
        return AxiosMaster.post(`/api/justdial/getMyLeads`, data)
    };

    this.updateLead = function (data) {
        return AxiosMaster.put(`/api/justdial/updateLead`, data)
    };

    //Marketing
    this.searchPatientsForCamapign = function (data) {
        return AxiosMaster.post(`/api/user/searchPatientsV2`, data)
    };
    this.createCampaign = function (data) {
        return AxiosMaster.post(`/api/marketing/createCampaign`, data)
    };
    this.getCampaign = function (data) {
        return AxiosMaster.post(`/api/marketing/getCampaign`, data)
    };
    this.sendCustomMessage = function (data) {
        return AxiosMaster.post(`/api/report/sendCustomMessage`, data)
    };
    this.createUserCampaignSegments = function (data) {
        return AxiosMaster.post(`/api/marketing/createUserList`, data)
    };
    this.getUserCampaignSegments = function (data) {
        return AxiosMaster.post(`/api/marketing/getUserList`, data)
    };
    this.createCampaignTemplate = function (data) {
        return AxiosMaster.post(`/api/marketing/createCampaign`, data)
    };

    //Packages
    this.createPackages = function (data) {
        return AxiosMaster.post(`/api/packages/createClinicPackage`, data)
    };
    this.getPackages = function (data) {
        return AxiosMaster.post(`/api/packages/getClinicPackages`, data)
    };
    this.updatePackages = function (data) {
        return AxiosMaster.put(`/api/packages/updateClinicPackages`, data)
    };
    this.acceptPackage = function (data) {
        return AxiosMaster.put(`/api/packages/acceptPackage`, data)
    };
    this.getMyOpenPackagesRequests = function (data) {
        return AxiosMaster.post(`/api/packages/getMyOpenPackagesRequests`, data)
    };
    this.getMyClinicsPackages = function (data) {
        return AxiosMaster.post(`/api/packages/getMyClinicsPackages`, data)
    };

    //Master Package
    this.createMasterPackages = function (data) {
        return AxiosMaster.post(`/api/packages/createMasterPackage`, data)
    };
    this.getMasterPackages = function (data) {
        return AxiosMaster.post(`/api/packages/getMasterPackages`, data)
    };
    this.approvePackageRequest = function (data) {
        return AxiosMaster.post(`/api/packages/acceptPackage`, data)
    };
    this.updateMasterPackages = function (data) {
        return AxiosMaster.put(`/api/packages/updateMasterPackages`, data)
    };

    //Tests

    this.createMasterTests = function (data) {
        return AxiosMaster.post(`/api/packages/createMasterTest`, data)
    };
    this.getMasterTests = function (data) {
        return AxiosMaster.post(`/api/packages/getMasterTests`, data)
    };
    this.updateMasterTests = function (data) {
        return AxiosMaster.put(`/api/packages/updateMasterTests`, data)
    };

    this.createTest = function (data) {
        return AxiosMaster.post(`/api/packages/createClinicTest`, data)
    };
    this.getTests = function (data) {
        return AxiosMaster.post(`/api/packages/getClinicTest`, data)
    };
    this.updateTest = function (data) {
        return AxiosMaster.put(`/api/packages/updateClinicTest`, data)
    };
    this.acceptTest = function (data) {
        return AxiosMaster.post(`/api/packages/acceptTest`, data)
    };
    this.getMyClinicsTests = function (data) {
        return AxiosMaster.post(`/api/patient/getMyClinicsTests`, data)
    };
    this.buyTest = function (data) {
        return AxiosMaster.post(`/api/patient/buyTest`, data)
    };
    this.getTestRequests = function (data) {
        return AxiosMaster.post(`/api/packages/getOpenTestsRequests`, data)
    };
    this.createClinicTestBulk = function (data) {
        return AxiosMaster.post(`/api/packages/createClinicTestBulk`, data)
    };
    this.editClinicTestBulk = function (data) {
        return AxiosMaster.post(`/api/packages/editClinicTestInBulk`, data)
    };


    this.createNotification = function (data) {
        return AxiosMaster.post(`/api/marketing/createHealthNotifications`, data)
    };
    this.getNotifications = function (data) {
        return AxiosMaster.post(`/api/marketing/getHealthNotifications`, data)
    };
    this.updateNotification = function (data) {
        return AxiosMaster.put(`/api/marketing/editHealthNotification`, data)
    };


    //Report Title Fetch
    this.getReportTitle = function (data) {
        return AxiosMaster.post(`/api/report/getReportsConfig`, data)
    };
    //Report Template Fetch
    this.getReportTemplate = function (data) {
        return AxiosMaster.post(`/api/report/getReportsTemplateConfigV2`, data)
    };

    //Create Prescription
    this.createPrescription = function (data) {
        return AxiosMaster.post(`/api/prescriptions/createPrescription`, data)
    };

    //Create Prescription
    this.createPrescription = function (data) {
        return AxiosMaster.post(`/api/prescriptions/createPrescription`, data)
    };

    //Search Medicines Or Prescription
    this.searchMedicinesOrPrescription = function (data) {
        return AxiosMaster.post(`/api/prescriptions/searchMedicinesOrPrescription`, data)
    };

    //Search Notes Data For Prescription
    this.searchNotesDataForPrescription = function (data) {
        return AxiosMaster.post(`/api/prescriptions/searchNotesDataForPrescription`, data)
    };

    //Get Prescription
    this.getPrescription = function (data) {
        return AxiosMaster.post(`/api/prescriptions/getPrescription`, data)
    };

    //Get Prescription Template
    this.getPrescriptionTemplates = function (data) {
        return AxiosMaster.post(`/api/prescriptions/searchPrescriptionTemplate`, data)
    };

    //Create Prescription Template
    this.createPrescriptionTemplates = function (data) {
        return AxiosMaster.post(`/api/prescriptions/createPrescriptionTemplate`, data)
    };

    //Update Prescription Template
    this.updatePrescriptionTemplates = function (data) {
        return AxiosMaster.put(`/api/prescriptions/updatePrescriptionTemplate`, data)
    };

    //Get All Prescription Template
    this.getAllPrescriptionTemplates = function (data) {
        return AxiosMaster.post(`/api/prescriptions/getPrescriptionTemplate`, data)
    };

    //Get Prescription Clinical Notes
    this.getClinicalNotes = function (data) {
        return AxiosMaster.post(`/api/prescriptions/getClinicalNotes`, data)
    };

    //Get Prescription Clinical Doctor Notes
    this.getClinicalDoctorNotes = function (data) {
        return AxiosMaster.post(`/api/prescriptions/getClinicalNotesDoctor`, data)
    };

    //Update Prescription Clinical Doctor Notes
    this.updateClinicalDoctorNotes = function (data) {
        return AxiosMaster.put(`/api/prescriptions/updateClinicalNotesDoctor`, data)
    };

    //Create Investigation
    this.createInvestigation = function (data) {
        return AxiosMaster.post(`/api/prescriptions/createInvestigation`, data)
    };

    //Create Medication
    this.createMedication = function (data) {
        return AxiosMaster.post(`/api/prescriptions/createMedication`, data)
    };

    //Create Prescription Clinical Notes
    this.createClinicalNotes = function (data) {
        return AxiosMaster.post(`/api/prescriptions/createClinicalNotes`, data)
    };

    //Update Prescription Clinical Notes
    this.updateClinicalNotes = function (data) {
        return AxiosMaster.put(`/api/prescriptions/updateClinicalNotes`, data)
    };

    //Create Bill
    this.createBill = function (data) {
        return AxiosMaster.post(`/api/prescriptions/createBill`, data)
    };

    //Get Bill
    this.getBills = function (data) {
        return AxiosMaster.post(`/api/prescriptions/getBills`, data)
    };


    //Get Report Templates
    this.getAllReportTemplates = function (data) {
        return AxiosMaster.post(`/api/prescriptions/getClinicReportTemplate`, data)
    };

    //Update Report Templates
    this.updateAllReportTemplates = function (data) {
        return AxiosMaster.put(`/api/prescriptions/updateReportTemplate`, data)
    };

    //Get Report Config
    this.getReportConfig = function (data) {
        return AxiosMaster.post(`/api/prescriptions/getClinicReportConfigs`, data)
    };

    //Update Report Config
    this.updateReportConfig = function (data) {
        return AxiosMaster.put(`/api/prescriptions/updateReportTemplateConfig`, data)
    };
    //Get FTP Report
    this.getFTPfiles = function (data) {
        return AxiosMaster.post(`/api/report/getCustomFTPFiles`, data)
    };
    //Update FTP Report
    this.updateFTPfile = function (data) {
        return AxiosMaster.put(`/api/report/updateCustomFtpFileRecord`, data)
    };


    //create Intent
    this.createIntent = function (data) {
        return AxiosMaster.post(`/api/user/createClinicIntent`, data)
    };
    //get Intent
    this.getIntent = function (data) {
        return AxiosMaster.post(`/api/user/getClinicIntents`, data)
    };
    //rejectAccept Intent
    this.rejectAcceptIntent = function (data) {
        return AxiosMaster.put(`/api/user/acceptRejectIntent`, data)
    };

    //pusher API
    this.registerUser = function (data) {
        return AxiosMaster.post(`/api/user/registerUserToPusher`, data)
    };
    this.authenticatePusherChatUser = function () {
        return AxiosMaster.get(`/api/user/authenticatePusherChatUser`)
    };
    this.createPusherChatGroup = function (data) {
        return AxiosMaster.post(`/api/user/createPusherChatGroup`, data)
    };
    this.getMyPusherChatRooms = function (data) {
        return AxiosMaster.post(`/api/user/getMyPusherChatRooms`, data)
    };


    this.getOpenRequests = function (data) {
        return AxiosMaster.post(`/api/packages/getOpenRequests`, data)
    };

    this.getReviews = function (data) {
        return AxiosMaster.post(`/api/user/getReviews`, data)
    };


    //Payment
    this.getPaymentList = function (data) {
        return AxiosMaster.post(`/api/payment/getPaymentsOrderDetails`, data)
    };

    //Buy Test
    this.bookTest = function (data) {
        return AxiosMaster.post(`/api/packages/admin/buyTest`, data)
    }//Search Test
    this.searchTest = function (data) {
        return AxiosMaster.post(`/api/packages/searchTest`, data)
    }
    //Initiate Payment Link
    this.initiatePaymentLink = function (data) {
        return AxiosMaster.post(`/api/payment/triggerPaymentLinkToPatient`, data)
    }


};
let api = new API();

export default api;




// WEBPACK FOOTER //
// ./src/api/Api.js